/*===================================
||
|| SiteHeaderContext
||
===================================*/
import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import PromoBanners from "./components/PromoBanners";
import ScrollToPinned from "./components/ScrollToPinned.js";
import Mobile from "./Mobile";
import TabletDesktop from "./TabletDesktop";

const SiteHeader = () => {
    const { isVisible } = useSiteHeader();
    if (!isVisible) return null;
    return (
        <>
            <PromoBanners />
            <ScrollToPinned>
                <TabletDesktop />
                <Mobile />
            </ScrollToPinned>
        </>
    );
};

export default SiteHeader;
